<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
      >
        <div v-for="(member, index) in list" :key="index">

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                  label="姓名:"
                  prop="name"
              >
                <span>{{ member.name }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="性别:"
                  prop="sex"
              >
                <span>{{ member.sex }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="身份证号:"
                  prop="num"
              >
                <span>{{ member.num }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="联系电话:"
                  prop="phone"
              >
                <span>{{ member.phone }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="微信:"
                  prop="weixin"
              >
                <span>{{ member.weixin }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="申报项目:"
                  prop="project"
                  v-if="row.memberstatus == 6"
              >
                <span>{{ member.project }}</span>
              </el-form-item>

              <el-form-item label="选择项目" prop="oldgrade" v-else>
                <el-radio-group v-model="member.project">
                  <el-radio :label="item" v-for="item in projectColumns" :key="item">{{ item }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>


          </el-row>

        </div>

        <el-row v-if="row.memberstatus != 6">
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">确认报名
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>

      </el-form>

    </div>
  </div>
</template>
<style scoped>
.member-service-box .van-cell__value {
  color: #333;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}
</style>

<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import IdCardPicker from "../../../components/picker/IdCardPicker.vue";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Icon,
  PullRefresh,
  List,
  Tag,
  Button,
  DropdownMenu,
  DropdownItem,
  DatetimePicker
} from 'vant';
import area from "../../../utils/area";

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
export default {
  name: 'AbilityApplyMemberService',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    IdCardPicker,
    PicUploader,
    FileUploader
  },
  data: function () {
    return {
      validator,
      id: 0,
      active: 0,
      projectShow: false,
      showArea: false,
      showGradePicker: false,
      showProjectPicker: false,
      showOldGradePicker: false,
      showOldProjectPicker: false,
      actionShow: false,
      addShow: false,
      list: [],
      row: {},
      areaList: {},
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker: false,
      projectColumns: ['花球男', '花球女', '技巧男', '技巧女', '街舞男', '街舞女'],
      actions: [
        {name: '隐藏'},
        {name: '认证'},
      ],
      params: {
        pageNo: 1,
        pageSize: 10,
        keywords: '',
        cate_id: 0,
        is_show: 1
      },
      formData: {
        name: '',
        num: '',
        minzu: '',
        huzhao: '',
        cardtype: 1,
        birthday: '',
        sex: 1,
        zhengjianimg: [],
        pic: [],
        attsrc: [],
      },
      memberIndex: 0,
      saveLoading: false,
      isLoading: false,
      loading: false,
      finished: false,

    }
  },
  mounted() {
    document.title = "能力测试项目选择"
    this.areaList = area;
    this.params.id = this.$route.query.id
    this.getList();
  },
  computed: {},
  filters: {},
  destroyed() {
  },
  methods: {
    getList() {
      let that = this;
      that.$api.get('/api/ability/abilityApplyMemberList', that.params, (res) => {
        that.list = res.data.list;
        that.row = res.data.row;
      })
    },

    onProjectOpen(index) {
      this.projectShow = true
      this.memberIndex = index
    },

    onProjectConfirm(value) {
      console.log(value)
      this.list[this.memberIndex].project = value
      this.projectShow = false;
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData);
          that.formValidate = true;
          let count = 0
          that.list.map(field => {
            if (!field.project) {
              that.$message.warning(field.name + '请选择项目');
              count++
            }
          })
          if (count) {
            return
          }
          that.saveLoading = true;
          that.$api.post('/api/ability/memberServiceApply', {
            id: that.params.id,
            list: JSON.stringify(that.list)
          }, (res) => {
            that.saveLoading = false;
            that.getList()
            that.$message.success('报名成功')
          }, (res) => {
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      let count = 0
      that.list.map(field => {
        if (!field.project) {
          Toast(field.name + '请选择项目');
          count++
        }
      })
      if (count) {
        return
      }
      that.saveLoading = true;
      that.$api.post('/api/ability/memberServiceApply', {
        id: that.params.id,
        list: JSON.stringify(that.list)
      }, (res) => {
        that.saveLoading = false;
        that.getList()
        Toast.success('报名成功')
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    onTongbu() {
      let that = this;
      that.$api.post('/api/yundongyuan/tongbuCca', {}, (res) => {
        Toast(res.msg);
        that.onRefresh();
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    // 更改状态
    onStatusChange(index) {

      let that = this;
      that.params.is_show = index + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.is_show = 0;
      that.getList()
    },


  }
}
</script>



// WEBPACK FOOTER //
// AbilityApplyMemberService.vue?1fabc9ee